const isTruthyFeatureValue = (value) =>
  value == 'YES' || value == 'Yes' || value == 'yes' || value == 'true' || value === true;

export const fetchAmenitiesFromListing = (listing) => {
  const amenities = {};
  if (listing?.listing_features && listing.listing_features.length > 0) {
    listing.listing_features.forEach((group) => {
      group?.features?.forEach((item) => {
        amenities[item.feature_id] = isTruthyFeatureValue(item?.value) ? true : item?.value;
      });
    });
  }
  return amenities;
};

export const buildFeaturesRichFromListing = (listing) => {
  const out = {};
  if (!listing?.listing_features?.length) return out;
  listing.listing_features.forEach((group) => {
    group?.features?.forEach((item) => {
      const id = item?.id ?? item?.feature_id;
      if (id == null) return;
      const rawValue = item?.value;
      const isYes = isTruthyFeatureValue(rawValue);
      out[id] = {
        id,
        slug: item?.slug ?? null,
        value: isYes ? 'Yes' : rawValue != null && rawValue !== '' ? rawValue : null,
        value_l1: item?.value_l1 ?? (isYes ? 'نعم' : null),
      };
    });
  });
  return out;
};
